module.exports = __webpack_public_path__ + "static/varnish-3af1f776c3a2d6bbf5e9e1b85766d527.jpg";